import { render, staticRenderFns } from "./coletadores.vue?vue&type=template&id=81887b0c"
import script from "./coletadores.vue?vue&type=script&lang=js"
export * from "./coletadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports